// SidebarContext.jsx
import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
    const [ isSidebarOpen, setSidebarOpen ] = useState(false);

    return (
        <SidebarContext.Provider value={{ isSidebarOpen, setSidebarOpen }}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    return useContext(SidebarContext);
}